import React from "react";

/**
 * SectionHeading
 * Props:
 *  - eyebrow: small label text above the heading (optional)
 *  - title: main heading text
 *  - subtitle: supporting paragraph text (optional)
 *  - align: "center" | "start" (default "center")
 *  - light: boolean - use white text (for dark backgrounds)
 */
function SectionHeading({ eyebrow, title, subtitle, align = "center", light = false }) {
  const alignClass = align === "center" ? "text-center mx-auto" : "";
  return (
    <div className={`mb-5 ${alignClass}`} style={{ maxWidth: align === "center" ? "720px" : "none" }}>
      {eyebrow && (
        <div className={`section-title-eyebrow mb-2 ${light ? "text-saffron" : "text-orange"}`}>
          {eyebrow}
        </div>
      )}
      <h2 className={`fw-bold mb-3 ${light ? "text-white" : "text-navy"}`}>{title}</h2>
      <div className={`divider-brand ${align === "center" ? "mx-auto" : ""} mb-3`}></div>
      {subtitle && (
        <p className={light ? "text-white-50" : "text-secondary"}>{subtitle}</p>
      )}
    </div>
  );
}

export default SectionHeading;
